module.exports = __webpack_public_path__ + "static/media/Payment-failed.84ddf751.png";